import { GenIcon } from '../helpers/IconBase.es.js';

const WarningOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M9.06251 13.9808C9.06251 14.228 9.16128 14.465 9.33709 14.6398C9.51291 14.8146 9.75137 14.9128 10 14.9128C10.2486 14.9128 10.4871 14.8146 10.6629 14.6398C10.8387 14.465 10.9375 14.228 10.9375 13.9808C10.9375 13.7336 10.8387 13.4965 10.6629 13.3217C10.4871 13.1469 10.2486 13.0487 10 13.0487C9.75137 13.0487 9.51291 13.1469 9.33709 13.3217C9.16128 13.4965 9.06251 13.7336 9.06251 13.9808ZM9.37501 8.07775V11.6506C9.37501 11.7361 9.44532 11.806 9.53126 11.806H10.4688C10.5547 11.806 10.625 11.7361 10.625 11.6506V8.07775C10.625 7.99232 10.5547 7.92241 10.4688 7.92241H9.53126C9.44532 7.92241 9.37501 7.99232 9.37501 8.07775ZM18.666 16.6216L10.541 2.64076C10.4199 2.43299 10.2109 2.33008 10 2.33008C9.78907 2.33008 9.57813 2.43299 9.45899 2.64076L1.33399 16.6216C1.09376 17.0371 1.39454 17.5537 1.87501 17.5537H18.125C18.6055 17.5537 18.9063 17.0371 18.666 16.6216ZM3.36329 16.0798L10 4.65828L16.6367 16.0798H3.36329Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { WarningOutlined };
